function getAvailableQuantity(availability) {
  const channels = availability && availability.channels || {};
  const quantity = Object.entries(channels).map(
    ([channelId, channel]) => channel && channel.availableQuantity || 0
  ).reduce((acc, val) => acc + val, 0);
  return quantity;
}
export {
  getAvailableQuantity
};
//# sourceMappingURL=helpers.js.map
